import { gql } from '@apollo/client';
import { FlattenedUser } from '../../../types/user';
import {
	GetUserEmailBlockedOrUnblockedEventPropsEventFragment,
	UserType,
} from '#types';
import rpcShared from '@rockpapercoin/rpc-shared';
import { Typography } from '@mui/material';
import styles from './getUserEmailBlockedOrUnblockedEventProps.module.scss';

export const getUserEmailBlockedOrUnblockedEventPropsEventFragment = gql`
	fragment getUserEmailBlockedOrUnblockedEventPropsEvent on Event {
		id
		category
		message
		contact {
			id
		}
		inquiry {
			id
			organization {
				id
				createdAt
				subscription {
					id
					status
					subscriptionPlan {
						id
						type
					}
				}
				groups {
					name
				}
			}
		}
		orgUser {
			id
		}
	}
`;

export const getUserEmailBlockedOrUnblockedEventProps = (
	eventProps: {
		event: GetUserEmailBlockedOrUnblockedEventPropsEventFragment;
	},
	user: FlattenedUser,
	setPremiumSubscriptionRequiredModalOpen: ( arg: boolean ) => void
) => {
	if ( !eventProps.event.message ) {
		throw new Error( `Event ID ${ eventProps.event.id } missing required data` );
	}
	const orgUser =
		user?.isLoggedIn && user.userType === UserType.OrgUser ? user : undefined;

	const { contact, inquiry } = eventProps.event;

	const hasLeadsAccess = inquiry
		? rpcShared.subscriptions.canAccessPremium( inquiry.organization )
		: false;

	const inquiryLinkProps =
		hasLeadsAccess && inquiry
			? {
				link: {
					href: `/lead/${ inquiry.id }`,
				},
			  }
			: orgUser?.organization?.id === inquiry?.organization.id
				? {
					onClick: () => setPremiumSubscriptionRequiredModalOpen( true ),
			  }
				: undefined;

	const contactLinkProps = contact?.id
		? {
			link: {
				href: `/contact/${ contact?.id }`,
			},
		  }
		: undefined;

	const profileLinkProps = eventProps.event.orgUser
		? {
			link: {
				href: '/profile/',
			},
		  }
		: undefined;

	if ( !inquiryLinkProps && !contactLinkProps && !profileLinkProps ) {
		throw new Error( `Event ID ${ eventProps.event.id } missing required data` );
	}

	return {
		icon: 'email',
		links: [
			{
				type: 'secondary',
				text: 'View',
				...( inquiryLinkProps || contactLinkProps || profileLinkProps ),
			},
		],
		message: (
			<Typography className={ styles.message }>
				{ eventProps.event.message }
			</Typography>
		),
		event: eventProps.event,
	};

	return eventProps;
};
